// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-card-footer.card-footer {
  font-size: 12px;
  padding: 5px !important;
}

.project-card {
  margin-bottom: 40px;
}

.project-card-title {
  margin-top: 10px;
  margin-right: 10px;
  color: gray;
  font-size: 26px;
}

.project-card-title-line {
  margin-top: 10px;
  margin-right: 10px;
  color: gray;
  font-size: 16px;
  text-align: center;
}

.project-card-number {
  margin-right: 10px;
  color: black;
  font-size: 20px;
  background-color: #f3f3f3 !important;
  padding: 15px 22px 15px 22px;
  border-radius: 50%;
  width: 70px;
  height: 50px;
}

.project-lines {
  background-color: #f3f3f3;
}

.project-line-step {
  border: 2px solid #3cb599;
  background-color: white;
  text-align: center;
  color: #f3f3f3;
}

.project-line-step-header-name {
  font-weight: bold;
}
.project-line-step-name {
  font-weight: bold;
}

.step-done-visite {
  color: #3cb599;
}

.project-card-marge {
  background-color: white;
  text-align: center;
  padding: 10px;
  border: 2px solid #3cb599;
  color: #3cb599;
}

.step-done-offre {
  background-color: #ff9610;
  border: 2px solid #ff9610;
  color: white;
}
.step-done-compromis {
  background-color: #f68d8d;
  border: 2px solid #f68d8d;
  color: white;
}
.step-done-acte-definitif {
  background-color: #3cb599;
  border: 2px solid #3cb599;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Components/ProjectCard.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,oCAAoC;EACpC,4BAA4B;EAC5B,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd","sourcesContent":[".project-card-footer.card-footer {\r\n  font-size: 12px;\r\n  padding: 5px !important;\r\n}\r\n\r\n.project-card {\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.project-card-title {\r\n  margin-top: 10px;\r\n  margin-right: 10px;\r\n  color: gray;\r\n  font-size: 26px;\r\n}\r\n\r\n.project-card-title-line {\r\n  margin-top: 10px;\r\n  margin-right: 10px;\r\n  color: gray;\r\n  font-size: 16px;\r\n  text-align: center;\r\n}\r\n\r\n.project-card-number {\r\n  margin-right: 10px;\r\n  color: black;\r\n  font-size: 20px;\r\n  background-color: #f3f3f3 !important;\r\n  padding: 15px 22px 15px 22px;\r\n  border-radius: 50%;\r\n  width: 70px;\r\n  height: 50px;\r\n}\r\n\r\n.project-lines {\r\n  background-color: #f3f3f3;\r\n}\r\n\r\n.project-line-step {\r\n  border: 2px solid #3cb599;\r\n  background-color: white;\r\n  text-align: center;\r\n  color: #f3f3f3;\r\n}\r\n\r\n.project-line-step-header-name {\r\n  font-weight: bold;\r\n}\r\n.project-line-step-name {\r\n  font-weight: bold;\r\n}\r\n\r\n.step-done-visite {\r\n  color: #3cb599;\r\n}\r\n\r\n.project-card-marge {\r\n  background-color: white;\r\n  text-align: center;\r\n  padding: 10px;\r\n  border: 2px solid #3cb599;\r\n  color: #3cb599;\r\n}\r\n\r\n.step-done-offre {\r\n  background-color: #ff9610;\r\n  border: 2px solid #ff9610;\r\n  color: white;\r\n}\r\n.step-done-compromis {\r\n  background-color: #f68d8d;\r\n  border: 2px solid #f68d8d;\r\n  color: white;\r\n}\r\n.step-done-acte-definitif {\r\n  background-color: #3cb599;\r\n  border: 2px solid #3cb599;\r\n  color: white;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
